export const getImageAspectRatio = (height?: number | null, width?: number | null): number | undefined => {
  if (!height || !width) {
    return undefined;
  }

  return (height / width) * 100;
};
